export {footerQuery} from './footer.groq'
export {navigationLinksQuery} from './navigationLinks.groq'
